import IconChevronDown from 'assets/icons/chevron-down-stroke.svg';
import cn from 'classnames';
import { NestedEntryNavigationItem } from 'interfaces/navigation-data';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '../link';
import { useRootStore } from 'stores/use-root-store';

const DROPDOWN_TRACK_DELAY = 800;

const Dropdown: React.FC<
  Pick<NestedEntryNavigationItem, 'title' | 'items'> & {
    isNew?: boolean;
    onClick?: () => void;
    onItemClick?: (title: string) => void;
    setDropShadow: (arg: boolean) => any;
  }
> = ({ isNew = false, items, title, onClick, onItemClick, setDropShadow = () => null }) => {
  const petType = useRootStore((store) => store.petType);
  const [active, setActive] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (active && onClick) timer = setTimeout(() => onClick(), DROPDOWN_TRACK_DELAY);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [active, onClick]);

  return (
    <div
      className="relative flex px-2"
      onMouseEnter={() => {
        setActive(true);
        setDropShadow(true);
      }}
      onMouseLeave={() => {
        setActive(false);
        setDropShadow(false);
      }}
    >
      <button
        data-test={`nav-${petType}-${title}`}
        className="text-primary-main hover:text-other-black flex items-center text-sm font-medium focus:outline-hidden"
        onClick={onClick}
      >
        <FormattedMessage id={title} />
        <IconChevronDown className="text-primary-main w-6" />
        {isNew && <span className="bg-blue-neu absolute top-0 left-6 h-1 w-1 rounded-full" />}
      </button>
      <div
        className={cn(
          active ? 'block' : 'hidden',
          'border-other-white bg-other-white absolute top-full left-0 z-50 w-105 transform rounded-b-md border-2'
        )}
      >
        {items && (
          <div
            data-test={`nav-${petType}-${title}-dropdown`}
            className="bg-other-white z-50 mt-4 w-full"
          >
            {items.map((navItem) => {
              if (navItem.itemType === 'card' || navItem.itemType === 'entry') {
                return (
                  <Link
                    item={navItem}
                    key={navItem.title}
                    className="text-primary-main hover:bg-grey-100 hover:text-grey-700 z-50 my-2 block px-4 py-1 text-sm font-medium"
                    onClick={() => {
                      onItemClick?.(String(navItem.title));
                    }}
                  >
                    <FormattedMessage id={navItem.title} />
                  </Link>
                );
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
